var _rect, _g, _rect2, _g2, _rect3, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 17,
    viewBox: "0 0 52 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8531 6.26036H9.88826L8.35472 1.79883L6.81639 6.26036L1.85156 6.25584L5.87231 9.01602L4.33398 13.473L8.35472 10.7174L12.3707 13.473L10.8371 9.01602L14.8531 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1829 10.0266L10.8379 9.01758L8.35547 10.7189L11.1829 10.0266Z",
    fill: "#00B67A"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1699,
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_542_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.023 6.26036H45.0582L43.5246 1.79883L41.9863 6.26036L37.0215 6.25584L41.0422 9.01602L39.5039 13.473L43.5246 10.7174L47.5406 13.473L46.0071 9.01602L50.023 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3529 10.0266L46.0078 9.01758L43.5254 10.7189L46.3529 10.0266Z",
    fill: "#00B67A"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5859,
    width: 16.6596,
    height: 16.1849,
    fill: "#00B67A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_542_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.439 6.26036H27.4742L25.9407 1.79883L24.4023 6.26036L19.4375 6.25584L23.4582 9.01602L21.9199 13.473L25.9407 10.7174L29.9566 13.473L28.4231 9.01602L32.439 6.26036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7689 10.0266L28.4238 9.01758L25.9414 10.7189L28.7689 10.0266Z",
    fill: "#00B67A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(1.85156 1.79883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_542_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(37.0215 1.79883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_542_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9574,
    height: 12.5882,
    fill: "white",
    transform: "translate(19.4375 1.79883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars3);
export default __webpack_public_path__ + "static/media/stars_3.fc0926dc4a78c6ceb92b0a87a64f0934.svg";
export { ForwardRef as ReactComponent };